import React from "react"

import { FeedbackType } from "shared/types/FeedbackType"

import { FeedbackAttachment } from "features/feedback/model/useFeedback"

import { FeedbackOverlayView } from "./FeedbackOverlayView"
import { useFeedbackOverlayViewModel } from "./hooks/useFeedbackOverlayViewModel"

export interface FeedbackOverlayFormData {
  message?: string
  attachments?: FeedbackAttachment[]
}

export interface FeedbackOverlayModel {
  feedbackType: FeedbackType
  defaultFormData?: FeedbackOverlayFormData
  sendFeedback: (formData: FeedbackOverlayFormData) => void
  onCancel: () => void
}

export const FeedbackOverlay = React.memo((props: FeedbackOverlayModel) => (
  <FeedbackOverlayView {...useFeedbackOverlayViewModel(props)} />
))
